import { useState } from "react";

const testimonials = [
  {
    id: 1,
    name: "Mike M.",
    location: "Rogers, AR",
    rating: 5,
    date: "3 weeks ago",
    text: "They kept every promise that they made, including the quality of their work and time frame. They worked seamlessly with our insurance agent and made the whole process a breeze. They kept us informed from the get-go and were very professional throughout. I'm very impressed with this company and highly recommended them.",
    avatar: "M",
    verified: true,
  },
  {
    id: 2,
    name: "Sarah K.",
    location: "Bentonville, AR",
    rating: 5,
    date: "1 month ago",
    text: "RidgeCap GC handled our entire insurance claim from start to finish. I had no idea about the depreciation holdback until they explained it — we recovered over $8,000 that the insurance company wasn't going to tell us about. The roof looks incredible and the crew was professional and clean.",
    avatar: "S",
    verified: true,
  },
  {
    id: 3,
    name: "David R.",
    location: "Frisco, TX",
    rating: 5,
    date: "2 months ago",
    text: "After the hail storm, I got three bids. RidgeCap was the only one who actually sat down and explained my insurance estimate line by line. They found items the adjuster missed and got them added to the claim. End result: my insurance covered far more than I expected and I ended up with a better roof than I started with.",
    avatar: "D",
    verified: true,
  },
  {
    id: 4,
    name: "Jennifer L.",
    location: "Allen, TX",
    rating: 5,
    date: "3 months ago",
    text: "I was skeptical about the 'free roof' claims I'd heard from other contractors. RidgeCap was different — they educated me on the process, never pressured me, and delivered exactly what they promised. The hail-resistant upgrade was a nice bonus too.",
    avatar: "J",
    verified: true,
  },
  {
    id: 5,
    name: "Robert T.",
    location: "Springdale, AR",
    rating: 5,
    date: "4 months ago",
    text: "Second time using RidgeCap GC — first was for my rental property, then my primary home after the last storm. Both times they made the insurance process painless. They know exactly how to document everything so the claim goes through smoothly.",
    avatar: "R",
    verified: true,
  },
  {
    id: 6,
    name: "Amanda P.",
    location: "McKinney, TX",
    rating: 5,
    date: "5 months ago",
    text: "The team at RidgeCap actually answers their phone and follows up when they say they will. That alone puts them ahead of most contractors. Add in their insurance expertise and quality work, and you've got a company I'll recommend to everyone I know.",
    avatar: "A",
    verified: true,
  },
];

const stats = [
  { value: "5.0", label: "Google Rating", icon: "ri-star-fill" },
  { value: "200+", label: "5-Star Reviews", icon: "ri-user-star-line" },
  { value: "6", label: "Years Elite Contractor", icon: "ri-award-line" },
  { value: "$2.3M+", label: "Depreciation Recovered", icon: "ri-money-dollar-circle-line" },
];

export default function TestimonialsSection() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [showAll, setShowAll] = useState(false);

  const visibleTestimonials = showAll ? testimonials : testimonials.slice(0, 3);

  return (
    <section id="testimonials" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <div className="inline-flex items-center gap-2 bg-[#f97316]/15 text-[#f97316] text-xs font-bold uppercase tracking-widest px-4 py-2 rounded-full mb-5">
            <i className="ri-google-fill"></i>
            Google Reviews
          </div>
          <h2 className="text-3xl md:text-4xl font-black text-[#1a1a2e] leading-tight mb-4">
            What Homeowners Are Saying <br className="hidden md:block" />
            <span className="text-[#f97316]">About RidgeCap GC</span>
          </h2>
          <p className="text-gray-500 text-base max-w-2xl mx-auto leading-relaxed">
            Real reviews from real customers who discovered they were leaving money on the table — until they called us.
          </p>
        </div>

        {/* Stats bar */}
        <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-16">
          {stats.map((stat) => (
            <div
              key={stat.label}
              className="bg-[#f8f5f0] rounded-xl p-6 text-center border border-gray-100"
            >
              <div className="w-10 h-10 flex items-center justify-center bg-[#f97316]/10 rounded-lg mx-auto mb-3">
                <i className={`${stat.icon} text-[#f97316] text-lg`}></i>
              </div>
              <div className="text-[#1a1a2e] font-black text-2xl md:text-3xl">{stat.value}</div>
              <div className="text-gray-500 text-xs font-medium mt-1">{stat.label}</div>
            </div>
          ))}
        </div>

        {/* Featured testimonial (large) */}
        <div className="bg-[#1a1a2e] rounded-2xl p-8 md:p-12 mb-8 relative overflow-hidden">
          {/* Quote icon background */}
          <div className="absolute top-4 right-4 text-[#f97316]/10">
            <i className="ri-double-quotes-r text-9xl"></i>
          </div>

          <div className="relative z-10">
            {/* Stars */}
            <div className="flex items-center gap-1 mb-6">
              {[...Array(5)].map((_, i) => (
                <i key={i} className="ri-star-fill text-[#f97316] text-lg"></i>
              ))}
              <span className="text-white/60 text-xs ml-2">Verified Google Review</span>
            </div>

            {/* Quote */}
            <blockquote className="text-white text-lg md:text-xl leading-relaxed mb-8 max-w-3xl">
              "{testimonials[activeIndex].text}"
            </blockquote>

            {/* Author */}
            <div className="flex items-center gap-4">
              <div className="w-12 h-12 flex items-center justify-center bg-[#f97316] rounded-full text-white font-bold text-lg">
                {testimonials[activeIndex].avatar}
              </div>
              <div>
                <div className="text-white font-bold">{testimonials[activeIndex].name}</div>
                <div className="text-white/60 text-sm">
                  {testimonials[activeIndex].location} • {testimonials[activeIndex].date}
                </div>
              </div>
              {testimonials[activeIndex].verified && (
                <div className="ml-auto flex items-center gap-1.5 bg-white/10 px-3 py-1.5 rounded-full">
                  <i className="ri-checkbox-circle-fill text-green-400 text-sm"></i>
                  <span className="text-white/80 text-xs font-medium">Verified Customer</span>
                </div>
              )}
            </div>
          </div>

          {/* Navigation dots */}
          <div className="flex items-center justify-center gap-2 mt-8">
            {testimonials.map((_, i) => (
              <button
                key={i}
                onClick={() => setActiveIndex(i)}
                className={`h-2 rounded-full transition-all duration-200 cursor-pointer ${
                  i === activeIndex ? "w-8 bg-[#f97316]" : "w-2 bg-white/30 hover:bg-white/50"
                }`}
              />
            ))}
          </div>
        </div>

        {/* Grid of additional testimonials */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {visibleTestimonials.map((t) => (
            <div
              key={t.id}
              onClick={() => setActiveIndex(testimonials.findIndex((item) => item.id === t.id))}
              className={`bg-[#f8f5f0] rounded-xl p-6 border border-gray-100 cursor-pointer transition-all duration-200 hover:border-[#f97316]/30 ${
                testimonials[activeIndex].id === t.id ? "ring-2 ring-[#f97316] ring-offset-2" : ""
              }`}
            >
              {/* Stars */}
              <div className="flex items-center gap-0.5 mb-4">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className="ri-star-fill text-[#f97316] text-xs"></i>
                ))}
              </div>

              {/* Excerpt */}
              <p className="text-gray-600 text-sm leading-relaxed mb-4 line-clamp-4">
                "{t.text.substring(0, 120)}..."
              </p>

              {/* Author */}
              <div className="flex items-center gap-3">
                <div className="w-8 h-8 flex items-center justify-center bg-[#1a1a2e] rounded-full text-white text-xs font-bold">
                  {t.avatar}
                </div>
                <div>
                  <div className="text-[#1a1a2e] font-bold text-sm">{t.name}</div>
                  <div className="text-gray-400 text-xs">{t.location}</div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* View more / Google link */}
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mt-10">
          <button
            onClick={() => setShowAll(!showAll)}
            className="inline-flex items-center gap-2 text-[#1a1a2e] font-bold text-sm hover:text-[#f97316] transition-colors cursor-pointer"
          >
            {showAll ? "Show Less" : `View All ${testimonials.length} Reviews`}
            <i className={showAll ? "ri-arrow-up-line" : "ri-arrow-down-line"}></i>
          </button>

          <span className="hidden sm:block text-gray-300">|</span>

          <a
            href="https://www.google.com/search?q=ridgecap+gc"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 bg-white border border-gray-200 hover:border-[#f97316] text-[#1a1a2e] font-bold px-5 py-2.5 rounded-full text-sm transition-colors cursor-pointer"
          >
            <i className="ri-google-fill text-[#4285F4]"></i>
            Read on Google
          </a>
        </div>
      </div>
    </section>
  );
}
